import React from 'react';
import { Link } from 'react-router-dom';

// Shared frame for the login, sign-up and password pages.
const AuthCard = ({ title, children }) => (
  <div style={{ maxWidth: 360, width: '90%', margin: '0 auto' }}>
    <h2 className="text-center mb-4">
      <Link to="/login" style={{ color: 'inherit', textDecoration: 'none' }}>
        <span role="img" aria-label="soup">🍲</span> Stew
      </Link>
    </h2>
    {title && <h5 className="text-center mb-3">{title}</h5>}
    {children}
  </div>
);

export default AuthCard;
